$(document).ready(function () {




  document.querySelectorAll('.mainContainer__offer-single .module').forEach(function(el, i) {
    el.classList.remove('module');
    el.classList.add('single__module');
  });

  document.querySelectorAll('.offerSingleDetails__slider .slick-arrow').forEach(function(el, i) {
    el.innerHTML = '';
  });

  $('.offerSingleDetails__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    asNavFor: '.offerSingleDetails__nav'
  });
  $('.offerSingleDetails__nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.offerSingleDetails__slider',
    focusOnSelect: true
  });

  $('.modules__inner.owl-carousel').owlCarousel({
    items: 1,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    mouseDrag: true,
    margin: 25,
    responsive: {
      1024: {
        items: 5
      }
    }
  });


  $('[data-front-slider]').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    speed: 1000,
    fade: true,
    useTransform: true,
    // cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    adaptiveHeight: true,
    appendArrows: $('.sliderHome__nav'),
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>'
  });


  // var wow = new WOW();
  // wow.init();

  var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax', {
      center: true
    });
  }

  $(".sliderOwl__arrowDown").on("click", function (e) {
    e.preventDefault();
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.intro').offset().top - 100
    }, 1500, 'swing');
  });

  $('#arrowMap').on('click', function() {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.contactPlaceMap').offset().top - 200
    }, 1500, 'swing');
  });

	var hash= window.location.hash

	// if ( hash == '' || hash == '#' || hash == undefined ) return false;


	      var target = $(hash);

				// console.log(target);

	      headerHeight = 120;
	      // target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				// console.log(hash);

				if (target.length) {
	        $('html,body').stop().animate({
	          scrollTop: target.offset().top - 125 //offsets for fixed header
	        }, 'linear');
	      }

});

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});
